import {
  cashDrawerPosModule,
  orderHubPosModule,
  paymentPosModule,
  tableLayoutPosModule,
} from '../PosModules/moduleFeatures';

export const defaultCashierPermissions = [
  {
    id: 591,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 592,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 593,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 594,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 595,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 596,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 597,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 598,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 599,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 600,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 601,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 602,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 603,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 604,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 605,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 606,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 607,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 608,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 609,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 610,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 611,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 612,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 613,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 614,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 615,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 616,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 617,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 618,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 619,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 620,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 621,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 622,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 623,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 624,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 625,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 626,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 627,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 628,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 629,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 630,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 631,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 632,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 633,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 634,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 635,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 636,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 637,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 119,
    key: 'bid-on-open-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 638,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 639,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 640,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 641,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 642,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 643,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 644,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 645,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 646,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 647,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 648,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 649,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 650,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 651,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 652,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 653,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 654,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 655,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 656,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 657,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 658,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 659,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 660,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 661,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 662,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 663,
    roleId: 9,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 664,
    roleId: 9,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 665,
    roleId: 9,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 666,
    roleId: 9,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 667,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 668,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1391,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1392,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1393,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1394,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1395,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1396,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1397,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1398,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1399,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1400,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1401,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1402,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1403,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 48,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1404,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 49,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1405,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 50,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1406,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1407,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1408,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1409,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1410,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1411,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1412,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1413,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1414,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1415,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1416,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1417,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1418,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1419,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1420,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1421,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'host-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1422,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1423,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1424,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1425,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1426,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1427,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1623,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1624,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1625,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3469,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3481,
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];
export const cashierDefaultPosPermission = [
  tableLayoutPosModule['assign-server-visible'],
  paymentPosModule['tenders-visible'],
  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible-is-approval-needed'],
  cashDrawerPosModule['other-stations-visible'],
];
